import { COMPLETED_VIEWS_KEY, NAV_LINKS, VALIDATION_MESSAGE_REQUIRED } from "../constants"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export const ScrollToTop = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export const setSessionStorage = (key, value) => {
  if (value === null || value === undefined) {
    if (window.localStorage.getItem(key))
      window.localStorage.removeItem(key)
    return
  }
  window.localStorage.setItem(key, JSON.stringify(value))
}

export const getSessionStorageValue = (key) => {
  if (!key) return null

  const savedValue = window.localStorage.getItem(key)
  if (savedValue === null || savedValue === undefined) return null

  return JSON.parse(savedValue)
}

export const setViewAsCompleted = (path) => {
  const completedViews = getSessionStorageValue(COMPLETED_VIEWS_KEY) || []
  setSessionStorage(COMPLETED_VIEWS_KEY, [
    ...new Set([...completedViews, path.replace("/", "")]),
  ])
}

export const getIsViewCompleted = (path) => {
  const completedViews = getSessionStorageValue(COMPLETED_VIEWS_KEY) || []
  return completedViews.includes(path)
}

export const isNullOrUndefined = (value) => {
  return value === null || value === undefined
}

export const getSavedFieldValue = (section, subsection, field, data, initialValue) => {
  if (!data) return ""
  const sectionData = data[section]
  if (
    !sectionData ||
    (subsection &&
      (isNullOrUndefined(sectionData[subsection]) ||
        isNullOrUndefined(sectionData[subsection][field]))) ||
    (!subsection && isNullOrUndefined(sectionData[field]))
  ) {
    return !isNullOrUndefined(initialValue) ? initialValue : ""

  }

  if (subsection) return sectionData[subsection][field]
  return sectionData[field]
}

export const updateFieldValue = (section, subsection, field, value) => {
  const sectionData = getSessionStorageValue(section) || {}
  if (subsection) {
    sectionData[subsection] = {
      ...(sectionData[subsection] || {}),
      [field]: value,
    }
  } else {
    sectionData[field] = value
  }
  setSessionStorage(section, sectionData)
}

export const getCurrentViewIndex = (path = "") => {
  const currentIndex = NAV_LINKS.findIndex(
    (view) => view.path === path || view.path === path.replace("/", "")
  )
  return currentIndex > -1 ? currentIndex : null
}

export const getPreviousAvailableView = (path) => {
  const currentIndex = getCurrentViewIndex(path)
  return currentIndex > 0 ? NAV_LINKS[currentIndex - 1] : null
}

export const getIsViewDisabled = (path) => {
  const previousView = getPreviousAvailableView(path)
  if (!previousView) return false

  return !getIsViewCompleted(previousView.path) && !getIsViewCompleted(path)
}

export const getFieldIsInvalid = (value, type, fieldInfo) => {
  if(type === "message") return false;
  if(type === 'radio' && fieldInfo.required) {
    return !isNullOrUndefined(value) ? ((value !== true && value !== false)) : true;
  }

  if ((value === "" || isNullOrUndefined(value)) && fieldInfo.required)
    return true
  const { pattern, min, max } = fieldInfo
  if (type === "number") {
    const num = Number(value)
    return (
      (!isNullOrUndefined(min) && num < min) ||
      (!isNullOrUndefined(max) && num > max)
    )
  } else if (pattern) {
    const regexp = new RegExp(pattern)
    return regexp.test(value) ? false : true
  }
  return false
}

export const getViewFieldsIncomplete = (view, data) => {
  if (!view || !view.sections) return false
  const { sections } = view
  return []
    .concat(
      ...sections.map((section) =>
        section.totalCalc
          ? [...section.inputFields, section.totalCalc]
          : section.inputFields
      )
    )
    .some((info) => {

      const { field, section, subsection, type } = info
      const value = getSavedFieldValue(section, subsection, field, data)

      const hasSubFields = info.options?.filter((option) => (option.subFields?.length > 0 && option.value === value));   
      const subFieldsInvalid = hasSubFields && hasSubFields.length ? hasSubFields.some((options) => {
          return options.subFields.some((subField) => {
            const { field, section, subsection, type } = subField;
            const value = getSavedFieldValue(section, subsection, field, data)
            return getFieldIsInvalid(value, type, subField)
          });
        }) : false;
      return subFieldsInvalid ? subFieldsInvalid : getFieldIsInvalid(value, type, info)
    })
}

export const convertToPercentages = (dataObject) => {
  return Object.keys(dataObject).reduce((result, key) => {
    let value = dataObject[key]
    if (key.toLowerCase().includes("percentage")) value = value * 100
    return {
      ...result,
      [key]: value,
    }
  }, {})
}


export const formatNumber = (input) => {  
  if (Number.isNaN(input)) {
    return input
  }
  return input.toLocaleString()
}

export const getValidationMessage = (value, type, fieldInfo) => {
const { min, max, required } = fieldInfo

  if(type === 'radio' && required) {
    return !isNullOrUndefined(value) && ((value !== true && value !== false)) ? VALIDATION_MESSAGE_REQUIRED : null;
  }

  if ((value === "" || isNullOrUndefined(value)) && fieldInfo.required) return VALIDATION_MESSAGE_REQUIRED


if(type === 'number') {
  const num = Number(value)
  if(!isNullOrUndefined(min) && num < min) return `Must be at least ${min}`
  if(!isNullOrUndefined(max) && num > max) return `Must be less than or equal to ${max}`
}
  return null;
}

export const getFieldsToSet = (field, value, sections) => {
  if (!sections || !field || isNullOrUndefined(value)) return null;

  return sections.reduce((fieldsToSet, section) => {
    const { inputFields } = section;
    if (inputFields) {
      const matchingInputField = inputFields.find(
      (inputField) =>
      inputField.field === field && inputField.options
      );

      if (matchingInputField) {
        const matchingOption = matchingInputField.options.find(
          (option) => option.value === value && option.fieldsToSet
        );

        if (matchingOption) {
          return matchingOption.fieldsToSet;
        }
      }
    }

    return fieldsToSet;
  }, null);
}

  export const updateGraphLabel = (label, resultsByLabel) => {
    let newLabel = label;
    if(label.includes('resultBy')) {
      if((resultsByLabel === 'kg' || resultsByLabel === 'tray')) {
          newLabel = label.replace(/kg CO2e/g, `gCO2e`);
        }
        newLabel = newLabel.replace(/\/resultBy/g, `/${resultsByLabel}`);
    }

    return newLabel;

  }
